import { Instagram, Linkedin, Youtube } from "lucide-react";
import { SnapchatIcon, XIcon, TikTokIcon } from "@/components/icons/SocialIcons";
import { useLanguage } from "@/contexts/LanguageContext";
import { Link, useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const columns = [
    {
      title: t("Products", "المنتجات"),
      links: [
        { label: t("Digital Bridge PRO", "ديجيتال بريدج برو"), to: "/pro" },
        { label: t("Bootcamp", "المعسكر التدريبي"), to: "/boot_camp" },
        { label: t("Consultation", "الاستشارات"), to: "/consultation" },
        { label: t("Influencers", "المؤثرين"), to: "/influencers" },
      ],

    },
    {
      title: t("Company", "الشركة"),
      links: [
        { label: t("About Us", "من نحن"), to: "/#about" },
        { label: t("Portfolio", "أعمالنا"), to: "/case-studies" },
        // { label: t("Testimonial", "تقييم"), to: "/testimonial" },
        // { label: t("Team", "الفريق"), to: "/team" },
        // { label: t("Careers", "الوظائف"), to: "/careers" },
        { label: t("Contact Us", "تواصل معنا"), href: "mailto:info@digitalbridgesa.com" },
      ],
    },
    {
      title: t("Collaborate", "تعاون"),
      links: [
        { label: t("Vendors", "الموردون"), to: "/vendors" },
        // { label: t("Advertise With Us", "أعلن معنا"), to: "/advertise" },
        // { label: t("Events", "الفعاليات"), to: "/events" },
      ],
    },
    {
      title: t("Legal", "قانوني"),
      links: [
        { label: t("Privacy Policy", "سياسة الخصوصية"), to: "/privacy" },
        { label: t("Terms & Conditions", "الشروط والأحكام"), to: "/terms" },
      ],
    },
  ];

const socialLinks = [
    { icon: SnapchatIcon, href: "https://www.snapchat.com/add/digitalbridgesa", label: "Snapchat" },
    { icon: Instagram, href: "https://www.instagram.com/digitalbridgesa/", label: "Instagram" },
    { icon: XIcon, href: "https://twitter.com/digitalbridgesa", label: "X" },
    { icon: Linkedin, href: "https://www.linkedin.com/company/digitalbridgesa/", label: "LinkedIn" },
    { icon: Youtube, href: "https://www.youtube.com/@digitalbridgesa", label: "YouTube" },
    { icon: TikTokIcon, href: "https://www.tiktok.com/@digitalbridgesa", label: "TikTok" },
  ];

  return (
    <footer className="bg-black border-t border-white/10 text-white">
      <div className="container mx-auto px-4 py-12 lg:py-16">
        {/* Top: Brand + Columns */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-3 lg:col-span-1 mb-4 lg:mb-0 flex flex-col items-center text-center">
            <a href="/" className="flex items-center gap-2 mb-4" dir="ltr">
              <span className="text-xl font-light text-white">Digital</span>
              <span className="text-xl font-bold text-white">Bridge</span>
            </a>
            <p className="text-sm text-white/70 max-w-xs">
              {t(
                "Bridging the gap between where you are to where you want to be by digitalization.",
                "سد الفجوة بين موقعك الحالي والمكان الذي تريد الوصول إليه من خلال التحول الرقمي."
              )}
            </p>
          </div>

          {/* Link Columns */}
          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-semibold text-white mb-4">{col.title}</h4>
              <ul className="space-y-2">
                {col.links.map((link) => (
                  <li key={link.label}>
                    {"href" in link && link.href ? (
                      <a
                        href={link.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm text-white/70 hover:text-white transition-colors"
                      >
                        {link.label}
                      </a>
                    ) : (
                      <Link
                        to={(link as { to: string }).to}
                        onClick={() => window.scrollTo(0, 0)}
                        className="text-sm text-white/70 hover:text-white transition-colors"
                      >
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Social + Copyright */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-white/70">
            © {new Date().getFullYear()} Digital Bridge. {t("All rights reserved.", "جميع الحقوق محفوظة.")}
          </p>
          <div className="flex gap-3">
            {socialLinks.map((social) => (
              <a
                key={social.label}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={social.label}
                className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center text-white/70 hover:text-white hover:bg-white/20 transition-colors"
              >
                <social.icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
